export enum PortfolioViewByFields {
  PRODUCT = "PRODUCT",
  PRODUCT_CODE = "PRODUCT_CODE",
  CUSTOMER = "CUSTOMER",
  CUSTOMER_LOCATION = "CUSTOMER_LOCATION",
  SUPPLIER = "SUPPLIER",
}
